import { render, staticRenderFns } from "./TranslateMediaForm.vue?vue&type=template&id=20a8f525&scoped=true&"
import script from "./TranslateMediaForm.vue?vue&type=script&lang=js&"
export * from "./TranslateMediaForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslateMediaForm.vue?vue&type=style&index=0&id=20a8f525&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8f525",
  null
  
)

export default component.exports